import { Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject } from 'rxjs';

/** dtokgoz 05.10.2026: yeni sürümün en geç 15 dk içinde fark edilmesi yeterli. */
const KONTROL_ARALIGI = 15 * 60 * 1000;
/** Service worker 'registerWhenStable:30000' ile en geç 30 sn'de kaydolur; ilk kontrol ondan sonra. */
const ILK_KONTROL = 45 * 1000;

/**
 * Yeni sürüm uyarısı (masaüstü). Üst çubuktaki "Yeni Sürüm Bulundu (Yenile)" düğmesi buradan beslenir.
 *
 * Neden ayrı servis (eski hâli dk-header içinde abonelikti):
 * - Angular service worker güncellemeyi yalnız açılışta ve sayfaya dışarıdan gelindiğinde kontrol eder;
 *   gün boyu açık sekme hiç kontrol etmiyordu → uyarı çok geç ya da hiç gelmiyordu. Burada 15 dk'da bir
 *   ve sekmeye dönüldüğünde kontrol edilir.
 * - versionUpdates geçmişi saklamaz: haber üst çubuk ekrana gelmeden (giriş/yönlendirme sırasında)
 *   gelirse kayboluyordu. Servis uygulama açılışında (APP_INITIALIZER) başlatılır, durum BehaviorSubject'te tutulur.
 */
@Injectable({ providedIn: 'root' })
export class SurumGuncellemeService {
  readonly yeniSurum$ = new BehaviorSubject<boolean>(false);
  private basladi = false;

  constructor(private swUpdate: SwUpdate, private zone: NgZone) {}

  baslat() {
    if (this.basladi || !this.swUpdate.isEnabled) return;
    this.basladi = true;

    this.swUpdate.versionUpdates.subscribe((e) => {
      if (e.type === 'VERSION_READY') this.zone.run(() => this.yeniSurum$.next(true));
      else if (e.type === 'VERSION_INSTALLATION_FAILED') console.warn('Yeni sürüm indirilemedi:', e.error);
    });
    // Önbellekteki sürüm sunucuda artık yok: kullanıcı yenilemeden düzelmez, aynı düğmeyle uyar
    this.swUpdate.unrecoverable.subscribe(() => this.zone.run(() => this.yeniSurum$.next(true)));

    const kontrol = () => {
      if (!this.yeniSurum$.value) this.swUpdate.checkForUpdate().catch(() => false);
    };
    // Zamanlayıcılar Angular dışında: sürekli çalışan aralık uygulamanın "stable" olmasını engellemesin
    this.zone.runOutsideAngular(() => {
      setTimeout(kontrol, ILK_KONTROL);
      setInterval(kontrol, KONTROL_ARALIGI);
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') kontrol();
    });
  }
}
